import React, { Fragment } from 'react'
import { Route, Switch } from 'react-router-dom'

import ProjectsManager from './ProjectsManager'
import ListInactiveProjects from './ListInactiveProjects'
import ShowProjectPage from './ShowProjectPage'
import NewProjectPage from './NewProjectPage'
import EditProjectPage from './EditProjectPage'

import NewQuote from '../Quotes/NewQuote'
import EditQuote from '../Quotes/EditQuote'
import PrintQuote from '../Quotes/PrintQuote'

import EditActual from '../Quotes/EditActual'
import PrintActual from '../Quotes/PrintActual'

const Projects = ({ match }) => (
  <Fragment>
    <Switch>
      <Route exact path={match.url + '/'} component={ProjectsManager} />
      <Route exact path={match.url + '/inactive'} component={ListInactiveProjects} />
      <Route exact path={match.url + '/new'} component={NewProjectPage} />
      <Route exact path={match.url + '/:id'} component={ShowProjectPage} />
    </Switch>
    <Route path={match.url + '/:id/edit'} component={EditProjectPage} />
    <Route
      path={match.url + '/:projectId/quotes/new'}
      exact
      component={NewQuote}
    />
    <Route
      path={match.url + '/:projectId/quotes/:quoteId/edit'}
      component={EditQuote}
    />
    <Route
      path={match.url + '/:projectId/quotes/:quoteId/print'}
      component={PrintQuote}
    />
    <Route
      path={match.url + '/:projectId/actuals/:actualId/edit'}
      component={EditActual}
    />
    <Route
      path={match.url + '/:projectId/actuals/:actualId/print/:actualType'}
      component={PrintActual}
    />
  </Fragment>
)

export default Projects



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.jsx